import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Response } from './response';


@Injectable()
export class CommonProvider {
    constructor(public http: HttpClient) {}
    // API curr base
    apiUrl = "https://api.teambuildr.fr/"
    // apiUrl = "http://localhost:3333/"
    s3PublicUrl:string = "https://tbr-companyfiles.s3.eu-west-3.amazonaws.com/"


    // Func for link previews
     linkParse(link): Observable<Linkpreview>
    {
        return this.http.post<Linkpreview>(this.apiUrl + 'api/v1/tools/scrap', {link})
    }
    // Search all users, clubs or post containing the specified query (naive func using %query% mySQL LIKE)
    searchAll(query): Observable<Response<any>>
    {
        return this.http.post<Response<any>>(this.apiUrl + 'api/v1/search/all', {query})
    }
}

export interface Linkpreview {
    description: string,
    title: string,
    image: string,
}



// WEBPACK FOOTER //
// ./src/providers/common.ts